import { ListLoader } from '@/components/base/listLoader'
import { Skeleton } from '@/components/ui/skeleton'

/**
 * The app while it boots (static config, onboarding gate): the frame of
 * the first screen — header line, a card, rows, the bottom bar in its
 * place — so the real screen fills in rather than replacing a blank page.
 */
export function AppShellSkeleton() {
    return (
        <div className="flex h-screen w-full flex-col">
            <div className="flex items-center justify-between px-3 py-2.5">
                <Skeleton className="h-4 w-28 rounded-md" />
                <Skeleton className="h-8 w-8 rounded-full" />
            </div>
            <div className="flex flex-1 flex-col gap-3 px-4">
                <Skeleton className="h-28 rounded-xl" />
                <ListLoader rows={4} />
            </div>
            <div
                aria-hidden="true"
                className="fixed bottom-2 left-4 right-4 h-12 rounded-2xl border border-white/10 bg-secondary/80"
            />
        </div>
    )
}
